<template>
  <div>
    <div class="nav-main">
      <ul class="nav-item">
        <li class="nav-li" @click="toPath('MB15993','/classification')">
          <img class="nav-img" :src="require('@/assets/images/plus/products.png')"/>
          <div class="nav-text">全部商品</div>
        </li>

        <li class="nav-li" @click="toPath(null,'/productList',{status:1})">
          <img class="nav-img" :src="require('@/assets/images/plus/brand.png')"/>
          <div class="nav-text">品牌专区</div>
        </li>
        <li class="nav-li" @click="toPath(null,'/plus')">
          <img class="nav-img" :src="require('@/assets/images/plus/plus.png')"/>
          <div class="nav-text">PLUS专区</div>
        </li>
        <li class="nav-li" @click="toPath('MB15995','/productList',{minPoint:1,maxPoint:totalPoint})">
          <img class="nav-img" :src="require('@/assets/images/plus/duihuan.png')"/>
          <div class="nav-text">我能兑换</div>
        </li>
        <li class="nav-li" @click="toPath('MB15996','/order')">
          <img class="nav-img" :src="require('@/assets/images/plus/order.png')"/>
          <div class="nav-text">我的订单</div>
        </li>
      </ul>

    </div>
    <div class="notice">
      <van-notice-bar left-icon="volume-o" :scrollable="false">
        <van-swipe vertical class="notice-swipe" :autoplay="3000" :show-indicators="false">
          <div class="text" v-for="(item,index) in list" :key="index">
            <van-swipe-item @click="noticedetail(item)">
              {{ item.title }}
            </van-swipe-item>
          </div>

        </van-swipe>
      </van-notice-bar>
    </div>

    <!-- <div class="tui-notice-board" bindtap="goWebview">
        <div class="tui-icon-bg">
            <img src="@/assets/icon/gonggao-2@2x.png" class="icon">
        </div>
        <div class="tui-scorll-div" bindtap="detail">
            <div class="tui-notice tui-animation">双11活动预告：全场5折，8折，9折起！</div>
        </div>
    </div> -->
  </div>
</template>

<script src="./dist/uplusapi.js"></script>
<script>
import UplusApi from '@uplus/uplus-api';
import { totalPoint, sysNotice } from '@/api/api';

export default {
  components: {},
  props: ['cmsData'],
  data() {
    return {
      instance: new UplusApi(),
      totalPoint: '0',
      list: []
    };
  },
  mounted() {
    this.upperFindTotalPoint();
    this.getNotice();
  },
  methods: {
    noticedetail(item) {
      this.$router.push({
        path: '/noticedetail',
        query: {
          notice: item
        }
      });
    },
    toPath(eventId, path, json) {
      if (eventId) {
        this.gioTrack(eventId);
      }
      this.$router.push({
        path: path,
        query: json || {}
      });
    },
    async gioTrack(eventId) {
      console.log(eventId);
      let this_ = this;
      await this_.instance.initDeviceReady();
      return this_.instance.upTraceModule && this_.instance.upTraceModule.gioTrack && this_.instance.upTraceModule.gioTrack({
        eventId
      }).then((res) => {
        console.log(res, '------------------');
        // alert("查看是否调通")
        // alert(res.retInfo);
        // alert(this_.eventId);
        // alert(eventId);
      }, (err) => {
        console.log(res.retInfo);
      });
    },
    async upperFindTotalPoint() {
      //获取总积分
      let params = {
        memberId: this.$cookies.get('memberId') || sessionStorage.getItem('memberId'),
      };
      let totalRes = await totalPoint(params);
      if (totalRes.code == '0000') {
        this.totalPoint = totalRes.data;
      }
    },
    async getNotice() {
      let params = {
        type: 1
      };
      const res = await sysNotice(params);
      if (res.code == '0000') {
        this.list = res.data.rows;
      }

    }
  },
};
</script>

<style scoped>
.notice-swipe {
  height: 40px;
  line-height: 40px;
}

.notice {
  padding: 30px 0;
}

.nav-main {
  /* margin-bottom: 44px; */
  height: 144px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-evenly;
  border-radius: 20px;
}

.nav-item {
  display: flex;
  /* flex-direction: column; */
  align-items: center;
  flex: 1;
  justify-content: space-between;
  height: 140px;
  padding: 0 20px;
  padding-top: 30px;
}

.nav-li {
  flex: 1;
  text-align: center;
}

.nav-text {
  color: #333333;
  font-size: 26px;
  font-family: 'PingFang SC';
  font-style: normal;
  font-weight: 400;
}

.nav-img {
  width: 70px;
  height: 70px;
  padding-bottom: 7px;
}
</style>
